// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UFO3v1DmaBCkjvVjqlie {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center
}
.he4VBJpob0tFYzLgB5_V {
    max-width: 300px
}
.vj9Gw88YCmxsg_RDLGKL {
    font-family: Noto Sans;
    font-size: 12px;
    font-weight: 400
}
.wHfTqC3mfcW1vGwoxToD {
    margin-bottom: 0.5rem;
    font-family: Noto Sans;
    font-weight: 500;
    --tw-text-opacity: 1;
    color: rgb(239 68 68 / var(--tw-text-opacity, 1))
}
.LpWeAmlX6aqCNiaL748Q {
    height: 38px;
    width: 137px;
    --tw-bg-opacity: 1;
    background-color: rgb(0 130 202 / var(--tw-bg-opacity, 1));
    font-family: Noto Sans;
    font-size: 14px;
    font-weight: 500;
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1))
}

.LpWeAmlX6aqCNiaL748Q:hover {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(0 130 202 / var(--tw-bg-opacity, 1)) !important;
    --tw-text-opacity: 1 !important;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important
}
.LpWeAmlX6aqCNiaL748Q:disabled,
.LpWeAmlX6aqCNiaL748Q[disabled] {
    cursor: not-allowed;
    border-style: none;
    --tw-bg-opacity: 1 !important;
    background-color: rgb(217 217 217 / var(--tw-bg-opacity, 1)) !important;
    --tw-text-opacity: 1 !important;
    color: rgb(149 149 149 / var(--tw-text-opacity, 1)) !important
}

.LpWeAmlX6aqCNiaL748Q:disabled:hover,
.LpWeAmlX6aqCNiaL748Q[disabled]:hover {
    border-style: none;
    --tw-bg-opacity: 1 !important;
    background-color: rgb(217 217 217 / var(--tw-bg-opacity, 1)) !important;
    --tw-text-opacity: 1 !important;
    color: rgb(149 149 149 / var(--tw-text-opacity, 1)) !important
}
`, "",{"version":3,"sources":["webpack://./src/components/ERenewGenerateQR/ERenewGenerateQR.module.css"],"names":[],"mappings":"AACE;IAAA,aAAgD;IAAhD,sBAAgD;IAAhD,mBAAgD;IAAhD;AAAgD;AAGhD;IAAA;AAAoB;AAGpB;IAAA,sBAAqD;IAArD,eAAqD;IAArD;AAAqD;AAGrD;IAAA,qBAA+C;IAA/C,sBAA+C;IAA/C,gBAA+C;IAA/C,oBAA+C;IAA/C;AAA+C;AAG/C;IAAA,YAAkG;IAAlG,YAAkG;IAAlG,kBAAkG;IAAlG,0DAAkG;IAAlG,sBAAkG;IAAlG,eAAkG;IAAlG,gBAAkG;IAAlG,oBAAkG;IAAlG;AAAkG;;AAIlG;IAAA,6BAAgC;IAAhC,qEAAgC;IAAhC,+BAAgC;IAAhC;AAAgC;AAIhC;;IAAA,mBAAiE;IAAjE,kBAAiE;IAAjE,6BAAiE;IAAjE,uEAAiE;IAAjE,+BAAiE;IAAjE;AAAiE;;AAKjE;;IAAA,kBAA8C;IAA9C,6BAA8C;IAA9C,uEAA8C;IAA9C,+BAA8C;IAA9C;AAA8C","sourcesContent":[".modalWrapper {\n  @apply flex flex-col items-center justify-center;\n}\n.imageWidth {\n  @apply max-w-[300px];\n}\n.subText {\n  @apply text-dashboardSub font-dashboardSub font-inter;\n}\n.expiryText {\n  @apply text-red-500 font-medium font-inter mb-2;\n}\n.applyButton {\n  @apply bg-secondary text-white w-[137px] h-[38px] text-dashboardMain font-dashboardMain font-inter;\n}\n\n.applyButton:hover {\n  @apply !bg-secondary !text-white;\n}\n.applyButton:disabled,\n.applyButton[disabled] {\n  @apply !bg-gray-100 !text-gray-300 border-none cursor-not-allowed;\n}\n\n.applyButton:disabled:hover,\n.applyButton[disabled]:hover {\n  @apply !bg-gray-100 !text-gray-300 border-none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalWrapper": `UFO3v1DmaBCkjvVjqlie`,
	"imageWidth": `he4VBJpob0tFYzLgB5_V`,
	"subText": `vj9Gw88YCmxsg_RDLGKL`,
	"expiryText": `wHfTqC3mfcW1vGwoxToD`,
	"applyButton": `LpWeAmlX6aqCNiaL748Q`
};
export default ___CSS_LOADER_EXPORT___;
